import React from 'react';
import ReactDOM from 'react-dom/client';
import {Provider} from 'react-redux';
import store from './app/store';
import { CookiesProvider } from "react-cookie";
import TagManager from 'react-gtm-module';
import { getIdioma } from "./utils/localStorage";
import App from './App';
import {I18nextProvider} from 'react-i18next';
import i18next from 'i18next';
import global_es from './translations/es/global.json';
import global_en from './translations/en/global.json';
import global_pt from './translations/pt/global.json';

i18next.init({
  interpolation: { escapeValue: false },
  lng: getIdioma(),
  resources: {
    es: {
      global: global_es
    },
    en: {
      global: global_en
    },
    pt: {
      global: global_pt
    }
  },
})

const tagManagerArgs = {gtmId: 'GTM-W7WBPBF'};
TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <CookiesProvider>
      <Provider store={store}>
        <I18nextProvider i18n={i18next}>
          <App />
        </I18nextProvider>
      </Provider>
    </CookiesProvider>
);

